<template>
  <AutoComplete
    id="assignee"
    v-model="model"
    :options="filteredAssignees"
    option-label="name"
    :option-disabled="'isDisabled'"
    :dropdown="true"
    :overlay-z-index="setDropdownZIndex ? constants.dropdownZIndex : null"
    @search="searchAssignee"
  >
    <template #option="{ option }">
      <div
        class="option dropdown-option"
        :title="RequestAssigneeFormatter.getRequestAssigneeTitle(option)"
      >
        <i
          :class="RequestAssigneeFormatter.getRequestAssigneeIconClass(option)"
          class="me-2"
          aria-hidden="true"
        />
        <span>{{ option.name }}</span>
      </div>
    </template>
  </AutoComplete>
</template>

<script setup lang="ts">
  import { ref, Ref } from 'vue';
  import AutoComplete from '@/VueComponents/SharedComponents/AutoComplete.vue';
  import constants from '@/constants';
  import RequestAssigneeFormatter from '@/Utils/requestAssigneeFormatter';
  import RequestAssigneeSummaryModel from '@/Models/RequestAssigneeSummaryModel';

  const props = defineProps<{
    assignees: RequestAssigneeSummaryModel[],
    setDropdownZIndex: boolean
  }>();
  const model = defineModel<RequestAssigneeSummaryModel | undefined>();
  const filteredAssignees: Ref<RequestAssigneeSummaryModel> = ref([]);

  function searchAssignee(event) {
    const query = event.query.trim();
    if (!query.length) {
      filteredAssignees.value = [...props.assignees];
    } else {
      filteredAssignees.value = props.assignees.filter(a => {
        return a.name.toLowerCase().includes(query.toLowerCase());
      });
    }
  }
</script>
<style scoped>
.option {
  white-space: normal;
}
</style>